import { useEffect } from "react";
import Hero from "@/components/fr/Hero";
import AboutSection from "@/components/fr/AboutSection";
import DonationSection from "@/components/fr/DonationSection";
import Footer from "@/components/fr/Footer";

const IndexFR = () => {
  useEffect(() => {
    const title = "NeuroResearch Foundation - Recherche sur les Maladies Neurologiques";
    const description = "Fondation dédiée à la recherche sur les maladies neurologiques : Douleur Chronique, Alzheimer, Parkinson et SLA. Faites un don pour soutenir la recherche de traitements innovants. Nous soutenons les associations de patients en Europe, notamment les maladies rares en Espagne et au Portugal. Nous sommes ravis de soutenir la recherche sur le système ECS et les connecteurs neuronaux.";
    
    document.title = title;
    
    const updateMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (selector.includes('property=')) {
          el.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
        } else if (selector.includes('name=')) {
          el.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:locale"]', 'content', 'fr_FR');
    updateMeta('meta[property="og:type"]', 'content', 'website');
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <AboutSection />
      <DonationSection />
      <Footer />
    </div>
  );
};

export default IndexFR;
